import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  API_PATH_AF_FILTER,
  AfFilter,
} from './afFilter.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getAfFilterList(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<AfFilter>> {
  return http.get(`${API_PATH_AF_FILTER}`);
}

export function getAfFilter(
  deliveryFunctionId: string,
  id: string,
): AxiosPromise<ServerResponse<AfFilter>> {
  return http.get(`${API_PATH_AF_FILTER}/${id}`);
}

export function createAfFilter(
  deliveryFunctionId: string,
  body: WithAuditDetails<AfFilter>,
): AxiosPromise<ServerResponse<AfFilter>> {
  return http.post(`${API_PATH_AF_FILTER}`, body);
}

export function updateAfFilter(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<AfFilter>,
): AxiosPromise<ServerResponse<AfFilter>> {
  return http.put(`${API_PATH_AF_FILTER}/${id}`, body);
}

export function deleteAfFilter(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<AfFilter>> {
  return http.delete(`${API_PATH_AF_FILTER}/${id}`, { data: body.auditDetails });
}
